import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *发布作品
 * @param params
 * 
*/

export const releaseWorks = params => Http.post(`${baseUrl}/works`, params )

/**
 *修改作品
 * @param params
 * 
*/

export const editWorks = params => Http.put(`${baseUrl}/works`, params )

/**
 *作品列表
 * @param params
 * 
*/

export const worksList = params => Http.get(`${baseUrl}/works`, { params })

/**
 *作品详情
 * @param worksId
 * 
*/

export const worksInfo = worksId => Http.get(`${baseUrl}/works/${worksId}` )


/**
 *删除作品(仅自己)
 * @param worksId
 * 
*/

export const delWorks = worksId => Http.delete(`${baseUrl}/works/${worksId}` )

/**
 *评论
 * @param params
 * 
*/

export const giveComment = params => Http.post(`${baseUrl}/works/comment`,  params )

/**
 *删除评论(仅自己)
 * @param commentId
 * 
*/

export const delComment = commentId => Http.delete(`${baseUrl}/works/comment/${commentId}` )

/**
 *评分
 * @param params
 * 
*/

export const giveGrade = params => Http.post(`${baseUrl}/works/grade`,  params )

/**
 *获取作品组内成员我的评分
 * @param worksId
 * 
*/

export const myTeamScore = worksId => Http.get(`${baseUrl}/works/${worksId}/team/user`)

/**
 *获取作品组内成员给我的评分
 * @param worksId
 * 
*/

export const myScore = worksId => Http.get(`${baseUrl}/works/${worksId}/team/my`)

/**
 *为组内成员评分
 * @param params
 * 
*/

export const giveMyTeamGrade = params => Http.post(`${baseUrl}/works/${params.worksId}/team/user/grade`,  params.arr )
